$(function () {
    $(document).on('af_complete', function(event, response) {
        if(response.success && typeof(yaCounter1572067) !== "undefined") {
            var form = response.form;
            if(form.attr('id') == 'prefooter-form' || form.attr('id') == 'indexbannerform') {
                yaCounter1572067.reachGoal('request');
            }
            if(form.attr('id') == 'popupCallbackForm') {
                yaCounter1572067.reachGoal('callback');
            }
            if(form.attr('id') == 'popupManagerOrder') {
                yaCounter1572067.reachGoal('ordermanager');
            }
        }
    });
});